
import center from '../Image/center.png';
import left from '../Image/left.png';
import right from '../Image/right.png';
const imageList = [center, left, right];
export default imageList;